import Aries from "./apps/future/images/signes/aries.svg";
import Taurus from "./apps/future/images/signes/taurus.svg";
import Gemini from "./apps/future/images/signes/gemini.svg";
import Cancer from "./apps/future/images/signes/cancer.svg";
import Leo from "./apps/future/images/signes/leo.svg";
import Virgo from "./apps/future/images/signes/virgo.svg";
import Libra from "./apps/future/images/signes/libra.svg";
import Scorpio from "./apps/future/images/signes/scorpio.svg";
import Sagittarius from "./apps/future/images/signes/sagittarius.svg";
import Capricorn from "./apps/future/images/signes/capricorn.svg";
import Aquarius from "./apps/future/images/signes/aquarius.svg";
import Pisces from "./apps/future/images/signes/pisces.svg";

const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

const convertTo24Hour = (hour, period) => {
  if (period === "PM" && hour < 12) return hour + 12;
  if (period === "AM" && hour === 12) return hour - 12;
  return hour
}
const findZodiacSign = (day, month) => {
  if ((month === 0 && day <= 19) || (month === 11 && day >= 22)) {
    return "Capricorn";
  } else if ((month === 0 && day >= 20) || (month === 1 && day <= 18)) {
    return "Aquarius";
  } else if ((month === 1 && day >= 19) || (month === 2 && day <= 20)) {
    return "Pisces";
  } else if ((month === 2 && day >= 21) || (month === 3 && day <= 19)) {
    return "Aries";
  } else if ((month === 3 && day >= 20) || (month === 4 && day <= 20)) {
    return "Taurus";
  } else if ((month === 4 && day >= 21) || (month === 5 && day <= 20)) {
    return "Gemini";
  } else if ((month === 5 && day >= 21) || (month === 6 && day <= 22)) {
    return "Cancer";
  } else if ((month === 6 && day >= 23) || (month === 7 && day <= 22)) {
    return "Leo";
  } else if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) {
    return "Virgo";
  } else if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) {
    return "Libra";
  } else if ((month === 9 && day >= 23) || (month === 10 && day <= 21)) {
    return "Scorpio";
  } else if ((month === 10 && day >= 22) || (month === 11 && day <= 21)) {
    return "Sagittarius";
  }
}

const singsImages = {
  Aries: Aries,
  Taurus: Taurus,
  Gemini: Gemini,
  Cancer: Cancer,
  Leo: Leo,
  Virgo: Virgo,
  Libra: Libra,
  Scorpio: Scorpio,
  Sagittarius: Sagittarius,
  Capricorn: Capricorn,
  Aquarius: Aquarius,
  Pisces: Pisces
};

const isValidDate = (year, month, day) => {
  /**
   * Checks if a given year, month, and day form a valid date using the Date object.
   *
   * @param {number} year - The year (e.g., 2023).
   * @param {number} month - The month (0-11).
   * @param {number} day - The day (1-31).
   * @returns {boolean} - True if the date is valid, false otherwise.
   */

      // Month is 0-indexed in Date, so subtract 1
  const date = new Date(year, month, day);

  // Check if the Date object's values match the input values
  return (
      date.getFullYear() === year &&
      date.getMonth() === month &&
      date.getDate() === day
  );
}

const renderString = (str, obj) => str.replace(/\${(.*?)}/g, (x,g)=> obj[g]);

export {getRandomInt, convertTo24Hour, findZodiacSign, renderString, isValidDate, singsImages};